module.exports = [
  { code: 'US', name: 'United States' }
];
